import { render, staticRenderFns } from "./RestList.vue?vue&type=template&id=4f8b2d45&scoped=true&"
import script from "./RestList.vue?vue&type=script&lang=js&"
export * from "./RestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8b2d45",
  null
  
)

export default component.exports